export const SCOPE = 'bbraunBavReportingFeatureAisReports';
